module.exports = "/_next/static/images/caravan-duotone-75a55b22477f6b7441bdcf1a4902778d.svg";